import {
    loadTheme,
    fontFace,
    ITheme,
    IPalette,
    ISemanticColors
} from "@fluentui/react/lib/Styling"

import selawkEot from "./Assets/selawik/selawk.eot"
import selawkSvg from "./Assets/selawik/selawk.svg"
import selawkTtf from "./Assets/selawik/selawk.ttf"
import selawkWoff from "./Assets/selawik/selawk.woff"
import selawkWoff2 from "./Assets/selawik/selawk.woff2"
import selawkbEot from "./Assets/selawik/selawkb.eot"
import selawkbSvg from "./Assets/selawik/selawkb.svg"
import selawkbTtf from "./Assets/selawik/selawkb.ttf"
import selawkbWoff from "./Assets/selawik/selawkb.woff"
import selawkbWoff2 from "./Assets/selawik/selawkb.woff2"
import selawksbEot from "./Assets/selawik/selawksb.eot"
import selawksbSvg from "./Assets/selawik/selawksb.svg"
import selawksbTtf from "./Assets/selawik/selawksb.ttf"
import selawksbWoff from "./Assets/selawik/selawksb.woff"
import selawksbWoff2 from "./Assets/selawik/selawksb.woff2"
import {
    DarkPalette,
    DefaultPalette,
    defaultSemanticColors
} from "./defaultTheme"

export * from "./defaultTheme"

fontFace({
    fontFamily: "Selawik Web",
    src: `url('${selawkWoff}') format('woff'),url('${selawkWoff2}') format('woff2'),url('${selawkTtf}') format('truetype'),url('${selawkEot}') format('embedded-opentype'),url('${selawkSvg}') format('svg')`,
    fontWeight: "normal",
    fontStyle: "normal"
})
fontFace({
    fontFamily: "Selawik Web",
    src: `url('${selawkWoff}') format('woff'),url('${selawkWoff2}') format('woff2'),url('${selawkTtf}') format('truetype'),url('${selawkEot}') format('embedded-opentype'),url('${selawkSvg}') format('svg')`,
    fontWeight: "400",
    fontStyle: "normal"
})

fontFace({
    fontFamily: "Selawik Web",
    src: `url('${selawkbWoff}') format('woff'),url('${selawkbWoff2}') format('woff2'),url('${selawkbTtf}') format('truetype'),url('${selawkbEot}') format('embedded-opentype'),url('${selawkbSvg}') format('svg')`,
    fontWeight: "700",
    fontStyle: "normal"
})
fontFace({
    fontFamily: "Selawik Web",
    src: `url('${selawksbWoff}') format('woff'),url('${selawksbWoff2}') format('woff2'),url('${selawksbTtf}') format('truetype'),url('${selawksbEot}') format('embedded-opentype'),url('${selawksbSvg}') format('svg')`,
    fontWeight: "600",
    fontStyle: "normal"
})
/**
 * Defines the theme for all CUI components.
 * @hideconstructor
 */
export class Theme {
    /**
     * The default CUI theme with encoway CI matching the CPQ product environment.
     * @memberof Theme
     */
    static DEFAULT = Theme.forPalette(DefaultPalette)

    /**
     * The default CUI dark theme with encoway CI matching the CPQ product environment.
     * @memberof Theme
     */
    static DARK = Theme.forPalette(DarkPalette)
    /**
     * Loads the given theme and initializes the MS Fluent icons.
     * @param {Object} theme - The theme.
     *
     * @example
     * import { Theme } from "@encoway/cui-configurator-components";
     * Theme.setup(Theme.DEFAULT);
     */
    static setup(theme: ITheme) {
        loadTheme(theme)
    }

    /**
     * Create a theme for a palette of colors and (optional) a definition of semantic colors.
     * @param {Object} palette - The palette to be used to create the theme.
     * @param {Object} semanticColors - The semantic colors to be used (may be undefined/null).
     *
     * @returns the theme object.
     * @example
     * import { Theme } from "@encoway/cui-configurator-components";
     * Theme.setup(Theme.create({ themePrimary:...}));
     * // or
     * Theme.setup(Theme.create({ themePrimary:...}, {bodyText:...}));
     */
    static create(
        palette: Partial<IPalette>,
        semanticColors?: ISemanticColors
    ) {
        return {
            defaultFontStyle: {
                fontFamily: "Selawik Web",
                fontWeight: "normal"
            },
            palette: { ...palette },
            semanticColors: {
                ...defaultSemanticColors(palette),
                ...(semanticColors || {})
            }
        } as unknown as ITheme
    }

    /**
     * Create a theme for a palette of colors.
     * @param {Object} palette - The palette to be used to create the theme.
     * @returns the theme object.
     * @example
     * import { Theme } from "@encoway/cui-configurator-components";
     * Theme.setup(Theme.forPalette({ themePrimary:...}));
     */
    static forPalette(palette: Partial<IPalette>) {
        return this.create(palette)
    }
}
